import "./Header.css";
import image4 from "../images/IMG-20240723-WA0024.jpg";
import img13 from "../images/5565381.jpg";
import img14 from "../images/88209500.jpg";
import img15 from "../images/ghk-fashion-marquee-1582133108.png";
import group from "../Icons/Group.png";
import Frame from "../Icons/Frame.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faMagnifyingGlass,
  faHeart,
  faUser,
  faCartPlus,
} from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { showRegister, searsh_product } from "../Redux/HomeSlice";
import { useDispatch } from "react-redux";
import { searsh_brand, change_personal_info } from "../Redux/API";
import SideMenu from "../SideMenu/SideMenu";

import i18n from "../i18n";

function Header(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getLocalStorage = window.localStorage.getItem("UserInfo");
  const valueLocalStorage = getLocalStorage
    ? JSON.parse(getLocalStorage)
    : null;
  const token =
    valueLocalStorage?.data?.token ||
    valueLocalStorage?.data?.data?.user?.token ||
    null;

  const gotoOffers = () => {
    setSearchValue("");
    navigate("/Offers");
    dispatch(searsh_product(false));
    window.scrollTo(0, 0);
  };
  const gotoNewArriva = () => {
    setSearchValue("");
    navigate("/NewArriva");
    dispatch(searsh_product(false));
    window.scrollTo(0, 0);
  };
  const gotoTrending = () => {
    setSearchValue("");
    navigate("/Trending");
    dispatch(searsh_product(false));
    window.scrollTo(0, 0);
  };
  const gotoFavorites = () => {
    if (token) {
      navigate("/Favorites");
      setSearchValue("");
      dispatch(searsh_product(false));
      window.scrollTo(0, 0);
    } else {
      dispatch(showRegister(true));
    }
  };
  const gotoPurchasing = () => {
    if (token) {
      navigate("/Purchasing");
      setSearchValue("");
      dispatch(searsh_product(false));
      window.scrollTo(0, 0);
    } else {
      dispatch(showRegister(true));
    }
  };
  const gotoHome = () => {
    navigate("/");
    setSearchValue("");
    dispatch(searsh_product(false));
    window.scrollTo(0, 0);
  };


  // languages
  const languages = ["En", "Ar"];
  const cantrys = [];

  const { t } = useTranslation();
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );

  useEffect(() => {
    i18n.changeLanguage(language);

    const body = document.body;
    if (language === "ar") {
      body.style.direction = "rtl";
      body.style.textAlign = "right";
    } else {
      body.style.direction = "ltr";
      body.style.textAlign = "left";
    }
  }, [language]);

  const [text, setText] = useState(localStorage.getItem("text") || "EN");

  const [icon, setIcon] = useState(false);
  function handelClick() {
    setIcon(!icon);
  }

  const [iconCantry, setIconCantry] = useState(false);
  const [imgCantry, setImgCantry] = useState(image4);
  function Clickcantry() {
    setIconCantry(!iconCantry);
  }

  const handleLanguageChange = (lang) => {

    const formData = new FormData();
    formData.append('preferred_language', language);
    dispatch(change_personal_info(formData));

    setLanguage(lang);
    localStorage.setItem("language", lang);

    const newText = lang === "ar" ? "AR" : "EN"; // هنا بنحدد النص بناءً على اللغة
    setText(newText);
    localStorage.setItem("text", newText); // نحفظ النص الجديد في localStorage

    window.location.reload(); 
  };

  const gotoProfile = () => {
    if (token) {
      navigate("/Profile"); 
      window.scrollTo(0, 0);
    } else {
      dispatch(showRegister(true));
    }
  };

  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);

    dispatch(searsh_product(value.length > 0));
    dispatch(searsh_brand({
      search: value,
      influencer_id: null, 
      brand_id: null, 
      store_id: null, 
      category_id: null
    }));
    window.scrollTo(0, 0);
  };

  const [isSideMenuOpen, setSideMenuOpen] = useState(false);

  const toggleSideMenu = () => {
    setSideMenuOpen(!isSideMenuOpen);
  };


  const menuLanguageRef = useRef(null); // مرجع لقائمة اللغات
  const menuCountryRef = useRef(null); // مرجع لقائمة الدول

  const handleClickOutside = (event) => {
    // تحقق إذا كان النقر خارج قوائم اللغات أو الدول
    if (
      menuLanguageRef.current &&
      !menuLanguageRef.current.contains(event.target)
    ) {
      setIcon(false);
    }
    if (
      menuCountryRef.current &&
      !menuCountryRef.current.contains(event.target)
    ) {
      setIconCantry(false);
    }
  };

  useEffect(() => {
    if (icon || iconCantry) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [icon, iconCantry]);

  return (
    <div className="Header">
      <div className="logo">
        <div className="logoImg">
          <img src={group} alt="logo" onClick={gotoHome} />
        </div>
        <div className="containers">
          <div className="cantry" ref={menuCountryRef}>
            <div className="slectList" onClick={Clickcantry} >
              <img src={imgCantry} alt="selected country" />
              <i
                className={`${iconCantry ? "activ_p" : "noActiv_p"}`}
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </i>
            </div>
            {iconCantry && (
              <div className="lest">
                {cantrys.map((e, i) => (
                  <img
                    src={e}
                    key={i}
                    alt={`country-${i}`}
                    onClick={() => (setImgCantry(e), setIconCantry(false))}
                  />
                ))}
              </div>
            )}
          </div>
          <div className="language" ref={menuLanguageRef}>
            <div className="slectList" onClick={handelClick}>
              <p>{text}</p>
              <i
                className={`${icon ? "activ_p" : "noActiv_p"}`}
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </i>
            </div>

            {icon && (
              <div className="lest">
                {languages.map((e, i) => (
                  <p
                    key={i}
                    onClick={() => (
                      setText(e),
                      setIcon(!icon),
                      handleLanguageChange(e.toLowerCase())
                    )}
                  >
                    {e}
                  </p>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className={`naveBar row justify-content-between align-items-center g-0 `}
      >
        <SideMenu
          isOpen={isSideMenuOpen}
          onClose={() => setSideMenuOpen(false)}
        />

        <div className={`taps col-12 col-sm-12 col-md-6`}>
          <div className="icon">
            <img src={Frame} alt="menu icon" onClick={toggleSideMenu} />
          </div>
          <div className="div" onClick={gotoTrending}>
            <img src={img13} />
            <span className="font-size1">{t('trending')}</span>
          </div>
          <div className="div" onClick={gotoNewArriva}>
            <img src={img14} />
            <span className="font-size1">{t("New arrival")}</span>
          </div>
          <div className="div" onClick={gotoOffers}>
            <img src={img15} />
            <span className="font-size1">{t("Offers")}</span>
          </div>
        </div>
        <div className={`cearch col-12 col-sm-12 col-md-6`}>
          <p className="border1">
            <div className="inpute_search border">
              <i className="magnifier">
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </i>
              <input
                type="text"
                className="srch-input"
                name="search"
                value={searchValue}
                onChange={handleSearchChange}
              />
            </div>
          </p>
          <i className="i font-size2" onClick={gotoProfile}>
            <FontAwesomeIcon icon={faUser} />
          </i>
          <i className="i font-size2" onClick={gotoFavorites}>
            <FontAwesomeIcon icon={faHeart} />
          </i>
          <i className="i font-size2" onClick={gotoPurchasing}>
            <FontAwesomeIcon icon={faCartPlus} />
          </i>
        </div>
      </div>
    </div>
  );
}

export default Header;
